import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { GrPowerReset } from "react-icons/gr";

import { BUTTON_KEYS, BUTTON_TYPE } from "@/constants/Button";

const ResetButton = ({ label, buttonProps = {}, onResetSelect }) => {
  const { t } = useTranslation();

  return (
    <Button
      icon={<GrPowerReset />}
      key={BUTTON_KEYS.RESET}
      role="button"
      type={BUTTON_TYPE.DEFAULT}
      onClick={onResetSelect}
      {...buttonProps}
    >
      {label ?? t("global:reset")}
    </Button>
  );
};

export default ResetButton;
